import { useEffect, useState } from "react";
import axiosProtected from "../api/config/baseWithToken";

const TTL_MS = 10 * 60 * 1000;
let cache = null;

// Average daily spend of the active store, cached for a few minutes because
// the sidebar mounts again on every page.
export default function useSpendRate(storeId) {
  const fresh = cache && cache.storeId === storeId && Date.now() - cache.at < TTL_MS;
  const [rate, setRate] = useState(fresh ? cache.value : null);

  useEffect(() => {
    if (!storeId) return undefined;
    if (cache && cache.storeId === storeId && Date.now() - cache.at < TTL_MS) {
      setRate(cache.value);
      return undefined;
    }
    let cancelled = false;
    axiosProtected
      .get("/store/spend-rate")
      .then(({ data }) => {
        cache = { storeId, at: Date.now(), value: data?.result || null };
        if (!cancelled) setRate(cache.value);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [storeId]);

  return rate;
}
